import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy redirect: the standalone Installs list page has been decommissioned
 * in favour of the unified Agents fleet (CLA-418). Kept so external links and
 * bookmarks (Linear, runbooks) continue to land on the right page.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/admin/installs/")({
  beforeLoad: () => {
    throw redirect({ to: "/clawinstall/admin/agents" });
  },
});
